import { render, staticRenderFns } from "./ApproveResult.vue?vue&type=template&id=f95a5be6&scoped=true&"
import script from "./ApproveResult.vue?vue&type=script&lang=js&"
export * from "./ApproveResult.vue?vue&type=script&lang=js&"
import style0 from "./ApproveResult.vue?vue&type=style&index=0&id=f95a5be6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95a5be6",
  null
  
)

export default component.exports